import getActivity from './getActivity';
import getActivities from './getActivities';
import getActivityPreview from './getActivityPreview';
import getNextItem from './getNextItem';

export default {
  getActivity,
  getActivities,
  getActivityPreview,
  getNextItem
};
